const fa = {
    "sc_title": "مرکز امنیت",
    "sc_subtitle": "لایه امنیتی یکپارچه GaiaShield",
    "sc_tab_status": "🛡️ وضعیت حفاظت",
    "sc_tab_events": "📋 گزارش امنیتی",
    "sc_tab_node": "⚙️ امنیت گره",
    "sc_loading": "در حال بارگذاری داده‌های امنیتی...",
    "sc_status_secured": "وضعیت سیستم: حساب محافظت شده است",
    "sc_status_warning": "وضعیت سیستم: هشدارهای فعال",
    "sc_desc_secured": "هیچ هشدار امنیتی بحرانی فعالی وجود ندارد. GaiaShield به طور فعال حساب شما را نظارت می کند.",
    "sc_desc_warning": "توجه: رویدادهای امنیتی فعالی وجود دارند که نیاز به توجه شما دارند.",
    "sc_account_protection": "محافظت از حساب",
    "sc_message_protection": "محافظت از پیام",
    "sc_audits": "ممیزی های امنیتی",
    "sc_active": "فعال",
    "sc_failed_logins": "ورودهای ناموفق",
    "sc_tamper_checks": "بررسی دستکاری",
    "sc_blocked_replays": "پخش های مجدد مسدود شده",
    "sc_last_check": "آخرین بررسی",
    "sc_just_now": "همین الان",
    "sc_open_warnings": "هشدارهای باز",
    "sc_btn_acknowledge": "تایید کردن",
    "sc_filter_severity": "شدت",
    "sc_filter_category": "دسته بندی",
    "sc_filter_hide_ack": "پنهان کردن تایید شده ها",
    "sc_btn_export": "خروجی گرفتن",
    "sc_col_details": "جزئیات",
    "sc_col_time": "زمان",
    "sc_col_status": "وضعیت",
    "sc_col_action": "عملیات",
    "sc_no_events": "هیچ رویداد امنیتی پیدا نشد.",
    "sc_node_title": "کنسول امنیتی اپراتور گره",
    "sc_system_health": "سلامت سیستم",
    "sc_last_audit": "آخرین حسابرسی",
    "sc_packed_logs": "گزارش های فشرده شده",
    "sc_unconfirmed_events": "رویدادهای تایید نشده",
    "sc_operator_action": "عملیات اپراتور مورد نیاز است",
    "sc_all_ok": "همه چیز مرتب است",
    "sc_critical_events": "رویدادهای بحرانی سیستم",
    "ac_title": "مرکز حاکمیت و گزارش سوء استفاده",
    "ac_subtitle": "اجماع حاکمیت و سوء استفاده GaiaCom",
    "ac_tab_my_reports": "گزارش های من",
    "ac_tab_queue": "صف بازبینی",
    "ac_tab_operator": "اپراتور گره",
    "ac_tab_transparency": "فدراسیون و شفافیت",
    "ac_loading": "در حال بارگذاری داده‌ها...",
    "ac_reported_cases": "موارد گزارش شده",
    "ac_no_reports": "شما هنوز هیچ گزارشی ارسال نکرده اید.",
    "ac_case_details": "جزئیات پرونده",
    "ac_appeal_submit": "ارائه درخواست تجدید نظر",
    "ac_appeal_status": "وضعیت درخواست تجدید نظر",
    "ac_appeal_reason": "دلیل درخواست تجدید نظر",
    "ac_appeal_statement": "اظهارات",
    "ac_btn_appeal": "ارسال درخواست تجدید نظر",
    "ac_trusted_reviewer_queue": "صف بازبین های مورد اعتماد",
    "ac_case_review": "بررسی پرونده",
    "ac_review_category": "دسته بندی پیشنهادی",
    "ac_review_severity": "شدت پیشنهادی",
    "ac_review_action": "اقدام پیشنهادی",
    "ac_review_reason": "دلیل بازبین",
    "ac_btn_submit_review": "ارسال بازبینی",
    "ac_node_operator_dashboard": "داشبورد اپراتور گره",
    "ac_apply_action": "اعمال اقدام (لغو کردن)",
    "ac_target_type": "نوع هدف",
    "ac_target_id": "شناسه هدف (GaiaID یا شناسه کانال)",
    "ac_suspend": "تعلیق فعال",
    "ac_reason": "دلیل رسمی",
    "ac_btn_apply": "اجرای اقدام",
    "ac_transparency_title": "دفترچه ثبت اجماع و شفافیت",
    "ac_transparency_desc": "اثبات های عکس فوری به صورت عمومی برای همه کانال ها و هویت های تعدیل شده قابل مشاهده است.",
    "ac_btn_snapshot": "ایجاد عکس فوری شفافیت",
    "search_placeholder": "جستجوی ایمیل‌ها بر اساس موضوع، فرستنده، متن...",
    "abuse_center_title": "مرکز سوء استفاده",
    "abbrechen": "لغو کنید",
    "active_identities": "هویت های فعال",
    "active_identity": "هویت فعال",
    "add_btn": "اضافه کنید",
    "add_contact_title": "افزودن مخاطب",
    "admin": "مدیر",
    "adressbuch": "دایرکتوری",
    "aktiviert": "فعال شد",
    "an": "به",
    "anonymous_sender": "فرستنده ناشناس",
    "antworten": "پاسخ دهید",
    "attachment_gaia_hint": "پیوست های GaiaCOM رمزگذاری شده باقی می مانند.",
    "attachment_smtp_hint": "SMTP قدیمی پیوست های اجرایی/اسکریپت مانند را مسدود می کند و ایمیل ها را به عنوان ناامن ذخیره می کند.",
    "attachments": "پیوست ها",
    "auffaellig": "مشکوک",
    "auth_beta_notice": "مرحله آزمایشی بتا: GaiaCOM به‌طور فعال در حال آزمایش است. ممکن است خطا رخ دهد; seedهای مهم را پشتیبان بگیرید و جریان‌های حساس را با دقت بررسی کنید.",
    "auth_btn_login": "بارگیری هویت و ورود به سیستم",
    "auth_btn_register": "ثبت نام و ایجاد رمزارز",
    "auth_copied": "کپی شده است",
    "auth_copy_seed": "Seed را کپی کنید",
    "auth_generate_seed": "بذر تولید کنید",
    "auth_headline": "GaiaCOM اولین پروتکل ایمیل و سیستم ارتباطی ایمن کوانتومی است که برای بشریت ساخته شده است.",
    "auth_kicker": "ارتباطات ایمن پس از کوانتومی",
    "auth_mnemonic": "عبارت یادگاری",
    "auth_mnemonic_placeholder": "12 کلمه جدا شده با فاصله...",
    "auth_password": "رمز عبور",
    "auth_password_placeholder": "•••••••••••••",
    "auth_proof_e2ee_desc": "کلیدهای خصوصی از دستگاه شما خارج نمی شوند. فقط گیرندگان مورد نظر می توانند محتوا را رمزگشایی کنند.",
    "auth_proof_gaiadata_desc": "Zero-knowledge: شما همچنان کنترل داده های خود را در دست دارید. فراداده به حداقل می رسد و به عنوان یک نمایه متن ساده استفاده نمی شود.",
    "auth_proof_gaiadrop_desc": "افراد خارجی می توانند پیام های متنی محرمانه را بدون حساب به GaiaID شما ارسال کنند.",
    "auth_proof_gaiaproof_desc": "شواهد تحویل و یکپارچگی نشان می دهد که متن رمز، فرستنده و مهر زمانی دستکاری نشده اند.",
    "auth_proof_gaiavault_desc": "یادداشت های خصوصی، یادداشت های بازیابی و سوابق امنیتی به صورت محلی رمزگذاری شده باقی می مانند.",
    "auth_proof_hybrid_desc": "سپر کوانتومی: رمزگذاری ترکیبی با ML-KEM و X25519 از حملات امروزی محافظت می کند و خطرات بعدی را ذخیره می کند.",
    "auth_secure_mail": "ایمیل فدرال کوانتومی ایمن",
    "auth_subline": "GaiaCOM یک سیستم ارتباطی امن کوانتومی برای ایمیل، چت، اتاق بحران، GaiaDrop و فایل های امنیتی محلی است. کلیدهای خصوصی در دستگاه شما باقی می مانند، محتوا رمزگذاری شده است، و شواهد را می توان بدون متن ساده صادر کرد.",
    "auth_success_btn": "اکنون وارد شوید",
    "auth_success_text": "حساب GaiaCOM شما ایجاد شده است. کلیدها به صورت محلی از seed شما مشتق شده اند و در سرور ذخیره نشده اند.",
    "auth_success_title": "ثبت نام با موفقیت انجام شد",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "ورود/حساب",
    "auth_toggle_login": "حساب از قبل وجود دارد",
    "auth_toggle_register": "ایجاد حساب کاربری جدید",
    "auth_usecase_text": "مناسب برای وکلا، شرکت ها، مقامات، روزنامه نگاران، افشاگران و پرونده های امنیتی خصوصی.",
    "auth_usecase_title": "برای ارتباطات حساس ساخته شده است",
    "auth_username": "نام کاربری",
    "auth_username_placeholder": "نام را وارد کنید...",
    "auth_value_chat": "چت E2E",
    "auth_value_drop": "سقوط امن",
    "auth_value_mail": "نامه امن",
    "auth_value_rooms": "GaiaRooms",
    "bestaetigen": "تایید کنید",
    "bestaetigt": "تایید شده",
    "bio_status": "بیوگرافی/وضعیت",
    "biography": "بیوگرافی",
    "change_password_desc": "رمز ورود سمت سرور شما را تغییر می دهد. عبارت بازیابی محلی شما به طور جداگانه توسط رمز عبور طاق/باز کردن قفل محافظت می شود.",
    "change_password_menu_desc": "رمز ورود GaiaCOM را به روز کنید.",
    "change_password_title": "رمز عبور را تغییر دهید",
    "channel_id": "آیدی کانال",
    "channel_name_label": "نام کانال",
    "chat_deleted_hidden": "چت حذف و پنهان شد.",
    "chat_input_placeholder": "پیام امن را وارد کنید...",
    "chat_start_hint": "گفتگو را شروع کنید! همه پیام های چت دارای رمزگذاری E2E ایمن کوانتومی هستند.",
    "choose_avatar": "آواتار را انتخاب کنید",
    "ciphertext_hash": "هش متن رمزنگاری شده",
    "clear_chat": "چت خالی",
    "clear_for_everyone": "برای همه خالی",
    "clear_for_me": "فقط واسه من خالیه",
    "click_to_write_mail": "برای نوشتن ایمیل کلیک کنید",
    "click_top_right": "در بالا سمت راست کلیک کنید روی",
    "close": "بستن",
    "code_kopieren": "کد را کپی کنید",
    "code_kopieren_success": "کد کپی شد",
    "confirm_clear_channel_desc": "آیا می خواهید این کانال را از نمای محلی خود پاک کنید؟",
    "confirm_clear_channel_title": "کانال خالی",
    "confirm_clear_chat": "آیا می خواهید این چت را خالی کنید؟",
    "confirm_clear_chat_desc": "آیا می خواهید این چت را خالی کنید؟",
    "confirm_clear_chat_title": "چت خالی",
    "confirm_clear_everyone": "آیا می خواهید چت را برای هر دو شریک خالی کنید؟ (OK = برای همه، لغو = فقط برای من)",
    "confirm_delete_everyone": "آیا می خواهید پیام هر دو شریک را حذف کنید؟ (OK = برای همه، لغو = فقط برای من)",
    "confirm_delete_msg": "آیا می خواهید این پیام را حذف کنید؟",
    "confirm_delete_msg_desc": "آیا می خواهید این پیام چت را حذف کنید؟",
    "confirm_delete_msg_title": "حذف پیام",
    "confirm_new_password": "رمز عبور جدید را تایید کنید",
    "copy": "کپی کنید",
    "create_btn": "ایجاد کنید",
    "create_channel_title": "ایجاد کانال",
    "create_group_is_crisis": "علامت گذاری به عنوان منطقه بحران",
    "create_group_title": "ایجاد گروه جدید",
    "crypto_lock_desc": "زمانی که GaiaCOM کلیدهای رمزنگاری محلی را از حافظه حذف می کند، کنترل می کند.",
    "crypto_lock_menu_desc": "تایمرهای بارگذاری مجدد و عدم فعالیت را کنترل کنید.",
    "crypto_lock_title": "قفل رمزنگاری",
    "crypto_session_duration": "پس از بارگذاری مجدد باز شد",
    "crypto_session_duration_desc": "جلسه کریپتو را فقط برای مدت زمان انتخاب شده در این برگه مرورگر باز نگه می دارد.",
    "cryptographic_fingerprint": "اثر انگشت رمزنگاری شده",
    "current_password": "رمز عبور فعلی",
    "data_minimization": "به حداقل رساندن داده‌ها",
    "decrypt_failed": "قابل رمزگشایی نیست",
    "delete": "حذف کنید",
    "delete_account_button": "حذف اکانت به صورت غیرقابل برگشت",
    "delete_account_confirm_label": "برای تایید، DELETE را وارد کنید",
    "delete_account_confirmation_error": "رمز عبور و تایید DELETE مورد نیاز است.",
    "delete_account_desc": "این حالت حساب، هویت، جلسات دستگاه، داده‌های GaiaDrop، ابرداده‌های آپلود و پیام‌های قابل انتساب سمت سرور را برای همیشه از بین می‌برد.",
    "delete_account_done_desc": "تمام داده‌های قابل تخصیص GaiaCOM حذف شده است.",
    "delete_account_done_title": "اکانت حذف شد",
    "delete_account_menu_desc": "حساب کاربری و داده های مرتبط را از بین ببرید.",
    "delete_account_not_authenticated": "هیچ حساب کاربری فعالی وجود ندارد.",
    "delete_account_title": "حذف اکانت",
    "delete_for_everyone": "حذف برای همه",
    "delete_for_me": "حذف فقط برای من",
    "device_current": "این دستگاه",
    "device_last_seen": "آخرین",
    "device_logout": "از سیستم خارج شوید",
    "device_sessions_desc": "جلسات فعال را بررسی کنید و دستگاه‌هایی را که دیگر به آن‌ها اعتماد ندارید لغو ثبت کنید.",
    "device_sessions_empty": "دستگاهی پیدا نشد",
    "device_sessions_menu_desc": "جلسات فعال را مدیریت و پایان دهید.",
    "device_sessions_title": "دستگاه های ثبت شده",
    "device_since": "از آنجایی که",
    "display_name": "نام نمایشی",
    "drop_address_copied": "آدرس GaiaDrop کپی شد.",
    "drop_btn_decrypting": "صندوق ورودی در حال رمزگشایی است...",
    "drop_btn_load": "صندوق ورودی GaiaDrop را بارگیری کنید",
    "drop_delete_desc": "آیا واقعاً می خواهید این قطره را برای همیشه حذف کنید؟",
    "drop_delete_title": "GaiaDrop را حذف کنید",
    "drop_desc": "کانال کاهش دانش صفر فقط متنی برای اعلامیه های خارجی، افشای مسئولانه و گزارش های محرمانه. احزاب خارجی می توانند بدون حساب با استفاده از GaiaID شما پیام ارسال کنند.",
    "drop_empty": "هنوز هیچ پیام GaiaDrop بارگیری نشده است.",
    "drop_id": "شناسه دراپ:",
    "drop_own_address": "آدرس GaiaDrop شما",
    "drop_proof": "DROP PROOF",
    "drop_title": "صندوق ورودی امن GaiaDrop",
    "dunkler_modus": "حالت تاریک",
    "e2e_chat_room_open": "اتاق چت E2E را باز کنید",
    "edit_profile": "ویرایش نمایه",
    "edit_profile_desc": "نام نمایشی، بیو و آواتار را سفارشی کنید.",
    "einladungscode": "کد دعوت",
    "enter_fingerprint_chars_confirm": "برای تایید، کاراکترهای اثر انگشت درخواستی را وارد کنید.",
    "envelope_hash": "هش پاکت نامه",
    "erasability": "قابلیت حذف",
    "erfolg": "موفقیت",
    "exclude_plaintext": "صادرات بدون متن ساده",
    "export_disclosure": "مورد امنیتی صادرات",
    "export_package_desc": "فقط در صورتی متن ساده را درج کنید که این افشای عمدی باشد.",
    "export_package_title": "بسته امنیتی صادراتی",
    "fehler": "اشتباه",
    "gaiacom_reader": "خواننده GaiaCOM",
    "gaiadrop_inbox_title": "صندوق ورودی GaiaDrop",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM ابرداده‌ها را به حداقل می‌رساند، کلیدهای خصوصی را محلی نگه می‌دارد، محتوا را سرتاسر رمزگذاری می‌کند و حذف کامل حساب را فعال می‌کند.",
    "gdpr_home_title": "100٪ مطابق با GDPR",
    "gdpr_reason_delete": "حذف حساب، حساب، هویت، جلسات محلی و داده های قابل تخصیص سمت سرور را حذف می کند.",
    "gdpr_reason_e2ee": "محتوای خصوصی فقط برای گیرندگان مورد نظر قابل رمزگشایی است.",
    "gdpr_reason_minimal": "فراداده فقط برای مسیریابی، تحویل و اعتبارنامه های امنیتی استفاده می شود.",
    "gdpr_reason_zero_knowledge": "کلیدهای خصوصی و داده های بازیابی به صورت محلی تحت کنترل کاربر باقی می مانند.",
    "gesendet": "ارسال شد",
    "gesperrt_verdaechtig": "مسدود شده / مشکوک",
    "group_delete_desc": "آیا واقعاً می خواهید این گروه را برای همیشه حذف کنید؟ همه کانال ها و پیام های این گروه حذف خواهند شد.",
    "group_delete_title": "حذف گروه",
    "group_description": "توضیحات",
    "group_icon_label": "نماد / آواتار گروه",
    "group_name": "نام گروه",
    "group_settings_avatar": "آواتار",
    "group_settings_desc": "توضیحات",
    "group_settings_is_crisis": "علامت گذاری به عنوان منطقه بحران",
    "group_settings_name": "نام گروه",
    "group_settings_title": "تنظیمات گروه",
    "groups_empty_desc": "یک فضای کاری امن برای پروژه، بحران یا ارتباطات تیمی ایجاد کنید.",
    "groups_empty_title": "هنوز چت گروهی وجود ندارد",
    "gruppe_beitreten": "به گروه پیوست",
    "gruppe_erstellen": "+ ایجاد گروه",
    "gruppe_verlassen": "گروه رو ترک کن",
    "gruppen_chats": "چت های گروهی",
    "heller_modus": "حالت روشن",
    "how_to_receive_drops": "چگونه دراپ دریافت کنم؟",
    "identitaets_assistent": "دستیار هویت",
    "inactivity_lock_duration": "در صورت غیر فعال بودن قفل شود",
    "inactivity_lock_duration_desc": "پس از این دوره بدون ورودی، GaiaCOM به طور خودکار از نظر رمزنگاری قفل می شود.",
    "inactivity_lock_notice": "GaiaCOM به دلیل عدم فعالیت رمزنگاری مسدود شده است.",
    "include_plaintext": "شامل متن ساده",
    "invite_code_label": "کد دعوت",
    "join_group_title": "به گروه بپیوندید",
    "kanaele": "کانال ها",
    "kanal_erstellen": "+ کانال",
    "kein_chat_ausgewaehlt": "هیچ گپی انتخاب نشده است",
    "kein_kanal_ausgewaehlt": "کانالی انتخاب نشده است",
    "keine_gruppe_ausgewaehlt": "هیچ گروهی انتخاب نشده است",
    "keine_mails": "هیچ ایمیلی در دسترس نیست.",
    "key_change_warn_desc": "کلید عمومی این مخاطب تغییر کرده است. قبل از اعتماد به اثر انگشت آن را بررسی کنید.",
    "key_change_warn_title": "هشدار رمزنگاری",
    "key_change_warning_changed": "تغییر کرده است. این ممکن است نشانه حمله مرد میانی باشد!",
    "key_change_warning_msg": "کلید هویت برای مخاطب",
    "key_transparency": "شفافیت کلید (تاریخچه کلید)",
    "kopiert": "کپی شده است",
    "kryptographische_schluessel": "کلیدهای رمزنگاری",
    "kryptographische_schluessel_desc": "نمایش کلیدهای خصوصی و عبارت seed پشتیبان.",
    "laden": "بارگذاری...",
    "leeren": "خالی",
    "loading": "بارگذاری...",
    "local_key_vault": "طاق کلید محلی",
    "local_keys_label": "کلیدهای محلی",
    "lock_on_reload": "همیشه بعد از بارگیری مجدد قفل کنید",
    "logout": "از سیستم خارج شوید",
    "mail_compose": "نوشتن ایمیل",
    "mein_profil": "پروفایل من",
    "melden": "گزارش دهید",
    "menu": "منو",
    "message": "اخبار",
    "message_id": "شناسه پیام",
    "message_pin": "سنجاق",
    "message_pinned_title": "پیام های پین شده",
    "message_react": "واکنش نشان دهید",
    "message_reply": "پاسخ دهید",
    "message_replying_to": "پاسخ به",
    "message_save": "ذخیره کنید",
    "message_saved": "ذخیره شد",
    "message_to_channel": "پیام به",
    "message_unpin": "حل کنید",
    "message_unsave": "پس انداز نکن",
    "mitglied": "عضو",
    "mitglieder": "اعضا",
    "ml_kem": "ML-KEM",
    "neue_mail": "ایمیل جدید",
    "never_auto_lock": "هرگز به صورت خودکار",
    "new_fingerprint": "اثر انگشت جدید",
    "new_identity": "هویت جدید",
    "new_password": "رمز عبور جدید",
    "no_description": "بدون شرح",
    "no_key_history": "هیچ تاریخچه کلیدی ثبت نشده است.",
    "no_specification": "مشخص نشده است",
    "old_fingerprint": "اثر انگشت قدیمی",
    "open_privacy_imprint": "حفاظت از چاپ و اطلاعات را باز کنید",
    "post_quantum_e2e": "E2E پس کوانتومی",
    "posteingang": "صندوق ورودی",
    "powered_by": "قدرتمند شده توسط",
    "privacy_imprint_menu_desc": "نمایش GDPR، حفاظت از داده ها و اطلاعیه قانونی.",
    "privacy_imprint_profile_desc": "GaiaCOM محتوای ارتباطی را بر اساس اصول کمینه سازی داده ها، رمزگذاری سرتاسر و کنترل کلید محلی پردازش می کند.",
    "privacy_imprint_title": "حفاظت از داده ها و اطلاعیه قانونی",
    "profil": "نمایه",
    "profile_details": "جزئیات پروفایل",
    "profile_settings_hint": "تنظیمات پروفایل در پنل سمت راست نمایش داده می شود.",
    "profile_unlock_desc": "به دلایل امنیتی، برای مشاهده کلیدهای رمزنگاری خصوصی خود باید رمز عبور خود را دوباره وارد کنید.",
    "proof_hash": "هش اثبات:",
    "public_drop_desc": "ارسال امن برای اطلاعات متنی خارجی بدون حساب GaiaCOM.",
    "public_drop_message": "اخبار",
    "public_drop_message_placeholder": "متن محرمانه را وارد کنید...",
    "public_drop_send": "GaiaDrop را ارسال کنید",
    "public_drop_sender": "یادداشت فرستنده اختیاری است",
    "public_drop_sender_placeholder": "نام، شماره پرونده یا ناشناس",
    "public_drop_target": "GaiaID را هدف بگیرید",
    "quanten_chat": "چت کوانتومی",
    "quantum_secure_exchange": "تبادل امن کوانتومی از طریق...",
    "quantum_secure_net": "GaiaCOM Quantum Secure Network (Ed25519 & ML-KEM)",
    "quantum_shield_desc": "شبکه GaiaCOM از حریم خصوصی شما با یک پروتکل رمزگذاری چند لایه و ترکیبی محافظت می کند که در برابر حملات رایانه های کوانتومی آینده محافظت می شود.",
    "quantum_shield_l1_desc": "از استاندارد FIPS 203 برای کپسوله کردن یک کلید مشترک متقارن استفاده می کند. از ضبط غیرفعال و رمزگشایی بعدی (\\",
    "quantum_shield_l1_title": "1. حفاظت پس از کوانتومی (ML-KEM-1024)",
    "quantum_shield_l2_desc": "یک روش کلاسیک و بسیار سریع تعویض کلید Diffie-Hellman که به عنوان یک لایه امنیتی اضافی در رویه ترکیبی عمل می کند.",
    "quantum_shield_l2_title": "2. رمزنگاری منحنی بیضوی (X25519)",
    "quantum_shield_l3_desc": "هر پیام و هر پاکت فدراسیون به صورت رمزنگاری امضا می شود تا صحت صحت فرستنده را صریحاً تأیید کند.",
    "quantum_shield_l3_title": "3. امضاهای دیجیتال (Ed25519)",
    "quantum_shield_l4_desc": "محتوای پیام را به صورت متقارن رمزگذاری می کند و فرستنده، گیرنده و ابرداده را به داده های اضافی تأیید شده (AAD) متصل می کند تا از حملات مجدد جلوگیری کند.",
    "quantum_shield_l4_title": "4. احراز هویت AAD (AES-256-GCM)",
    "quantum_shield_status": "وضعیت سپر کوانتومی",
    "receive_drops_step1": "GaiaID خود را (مثلاً از طریق دکمه کپی در بالا) با منابع خارجی به اشتراک بگذارید.",
    "receive_drops_step2": "آن‌ها صفحه ورود نمونه GaiaCOM شما را باز می‌کنند، به برگه می‌روند",
    "receive_drops_step3": "و پیام رمزگذاری شده خود را به آدرس شما در آنجا ارسال می‌کنند.",
    "receiver_gaia": "گیرنده GaiaCOM",
    "receiver_smtp": "گیرنده SMTP",
    "records_stored": "سوابق ذخیره شد",
    "refresh": "به روز رسانی",
    "report_abuse_desc": "آیا می خواهید این پیام را گزارش کنید و شواهد رمزنگاری سوء استفاده را به سرور ارسال کنید؟",
    "report_abuse_title": "گزارش تخلف",
    "reputation_status": "وضعیت اعتبار",
    "room_chat_start_hint": "گفتگو را شروع کنید! همه پیام‌های این کانال گروهی E2E غیرمتمرکز و ایمن با رمزگذاری کوانتومی هستند.",
    "room_policy_audit": "دنباله حسابرسی و چرخش کلید فعال است.",
    "room_policy_crisis": "اتاق بحران",
    "room_policy_e2ee": "فضای صفر دانش ایمن کوانتومی E2EE",
    "room_policy_title": "دستورالعمل های اتاق",
    "room_policy_zero_knowledge": "سیاست",
    "room_security_note_desc": "همه تغییرات کلیدی از طریق کلید شفافیت تایید می شوند. از GaiaVault برای گزارش‌های پشتیبان خصوصی استفاده کنید.",
    "room_security_note_title": "یادداشت امنیتی پین شده",
    "save_profile": "ذخیره نمایه",
    "schluessel_entsperrt": "🔑 دوباره کلید را قفل کنید",
    "search_gaia_label": "آدرس گایا را پیدا کنید",
    "security_warning_title": "هشدار امنیتی",
    "select_channel_chat": "یک کانال را از نوار کناری سمت چپ برای چت انتخاب کنید.",
    "select_contact_chat": "یک مخاطب را از پانل سمت چپ برای شروع یک چت E2E ایمن کوانتومی انتخاب کنید.",
    "select_mail_read": "ایمیلی را از لیست انتخاب کنید تا محتوای کوانتومی آن را بخوانید یا پیام جدیدی ایجاد کنید.",
    "senden": "ارسال کنید",
    "sender_signature": "امضای فرستنده",
    "server_log": "لاگ سرور:",
    "server_received": "سرور دریافت کرد",
    "session_lock": "قفل جلسه",
    "setup_address_keys": "ایجاد آدرس و مجموعه کلید",
    "setup_profile": "در نمایه تنظیم کنید",
    "smtp_inbox_title": "دریافت SMTP",
    "smtp_legacy_badge": "SMTP قدیمی / ناامن",
    "smtp_mode_option": "پل قدیمی SMTP",
    "smtp_security_warning": "این ایمیل از طریق پروتکل کلاسیک و رمزگذاری نشده SMTP ارسال شده است. هیچ رمزگذاری سرتاسری فعال نیست.",
    "smtp_security_warning_desc": "این پیام از اتاق امنیتی GaiaCom خارج می شود. تحویل SMTP گارانتی انتها به انتها بومی GaiaCom، ضمانت TrustMesh و تضمین Godmode از دروازه ارائه نمی دهد.",
    "spam_verdacht": "هرزنامه / مشکوک",
    "spam_warning_desc": "این پیام دارای سیگنال های شهرت مشکوکی است.",
    "spam_warning_title": "هشدار هرزنامه",
    "speichern": "ذخیره کنید",
    "sperren": "قفل کردن",
    "standard_group_status": "چت گروهی استاندارد (E2EE رمزگذاری شده)",
    "status": "وضعیت",
    "subject": "در رابطه با",
    "suchen": "یک آدرس جدید Gaia پیدا کنید...",
    "tage": "روزها",
    "time_unknown": "زمان نامعلوم",
    "transmission_mode": "حالت انتقال",
    "trust_age": "سن اعتماد",
    "trust_passport_title": "پاسپورت اعتماد",
    "unbestaetigt": "تایید نشده",
    "unknown_sender": "ناشناس",
    "unlock_btn": "باز کردن قفل",
    "unlock_btn_profile": "باز کردن قفل",
    "unlock_desc": "فایل کلید خصوصی شما به صورت رمزگذاری شده ذخیره می شود. رمز عبور خود را وارد کنید تا کلیدهای رمزنگاری فقط در حافظه بارگیری شوند.",
    "unlock_logout": "از سیستم خارج شوید و کلیدهای محلی را ببندید",
    "unlock_title": "باز کردن قفل هویت",
    "untrusted": "نامعتبر",
    "update_password": "رمز عبور را به روز کنید",
    "upload_avatar_btn": "آپلود تصویر (عفونی شده)",
    "vault_btn_encrypt": "رکورد را رمزگذاری کنید",
    "vault_btn_lock": "گاوصندوق را قفل کنید",
    "vault_btn_unlock": "گاوصندوق را باز کنید",
    "vault_copied_success": "در کلیپ بورد کپی شد",
    "vault_decrypted_content": "محتوای رمزگشایی شده",
    "vault_desc": "طاق رمزگذاری شده محلی برای پشتیبان‌گیری بازیابی، یادداشت‌های هویت، دسترسی به سرور، مخاطبین اضطراری، یادداشت‌های قانونی، رویدادهای امنیتی و گزارش‌های خصوصی.",
    "vault_empty": "هیچ سابقه ایمن هنوز ذخیره نشده است.",
    "vault_locked_pane_notice": "صندوق قفل است. لطفا از سمت راست باز کنید.",
    "vault_new_record": "رکورد جدید امن",
    "vault_pwd_placeholder": "رمز عبور Vault را وارد کنید...",
    "vault_record_body": "ضبط محتوا",
    "vault_record_body_placeholder": "محتوای رکورد رمزگذاری شده را وارد کنید...",
    "vault_record_category": "دسته بندی",
    "vault_record_title": "عنوان رکورد",
    "vault_record_title_placeholder": "عنوان سابقه امن",
    "vault_title": "GaiaVault Secure Records",
    "verify_new_fingerprint_hint": "قبل از پذیرش کلید، اثر انگشت جدید را بررسی کنید.",
    "vertrauenswuerdig": "قابل اعتماد",
    "vision_gaia_technology": "VisionGaiaTechnology",
    "von": "از",
    "warnung": "هشدار",
    "wizard_address": "آدرس",
    "wizard_back": "برگشت",
    "wizard_check1": "من بذرم را با خیال راحت نجات داده ام.",
    "wizard_custom_domain": "از دامنه خود استفاده کنید",
    "wizard_desc1": "GaiaCOM کلیدهای خصوصی را در سمت سرور ذخیره نمی کند. بدون Mnemonic Seed، هیچ کس نمی تواند پیام های از دست رفته را بازیابی کند.",
    "wizard_desc2": "آدرس شما گره فدرالی را تعیین می کند که پاکت های رمزگذاری شده از طریق آن مسیریابی می شوند.",
    "wizard_fallback": "گره های بازگشتی",
    "wizard_finish": "راه اندازی کامل",
    "wizard_next": "بیشتر",
    "wizard_server_domain": "دامنه گره سرور",
    "wizard_step1": "1. Backup Seed",
    "wizard_step2": "2. آدرس و سرور",
    "wizard_title1": "از کلید بازیابی نسخه پشتیبان تهیه کنید",
    "wizard_title2": "آدرس GaiaCOM را انتخاب کنید",
    "write_message_placeholder": "یک پیام امن بنویسید...",
    "you": "شما",
    "zero_knowledge": "دانش صفر",
    "zero_knowledge_encryption": "رمزگذاری دانش صفر",
    "Chat fuer alle geleert": "چت برای همه شرکت کنندگان خالی شده است.",
    "Chat geleert": "چت برای صندوق ورودی محلی شما پاک شده است.",
    "Nachricht fuer alle geloescht": "پیام برای همه شرکت کنندگان حذف شده است.",
    "Nachricht geloescht": "پیام چت به صورت محلی از صندوق ورودی شما حذف شده است.",
    "anpinnen": "سنجاق",
    "chat_loeschen": "حذف چت",
    "confirm_delete_chat_desc": "آیا مطمئن هستید که می خواهید چت را حذف و پنهان کنید؟",
    "confirm_leave_group_desc": "آیا واقعاً می خواهید این گروه را ترک کنید؟",
    "entpinnen": "پین را بردارید",
    "group_deleted": "گروه با موفقیت حذف شد.",
    "group_left": "با موفقیت گروه را ترک کنید",
    "gruppe_loeschen": "حذف گروه",
    "loeschen": "حذف کنید",
    "no_active_chats": "بدون چت فعال برای شروع یک چت، مخاطبین بالا را جستجو کنید.",
    "pinned": "پین شده",
    "wizard_check_credentials": "من مسئول حفظ امنیت اطلاعات دسترسی خود هستم.",
    "wizard_check_is_beta": "من می دانم که GaiaCom یک نرم افزار بتا است.",
    "wizard_check_no_illegal": "من از GaiaCom برای مقاصد غیرقانونی استفاده نخواهم کرد.",
    "wizard_check_no_uptime": "من می دانم که هیچ تضمینی برای در دسترس بودن وجود ندارد.",
    "wizard_check_smtp_security": "من می دانم که پیام های SMTP امنیت کامل GaiaCom را فراهم نمی کنند.",
    "wizard_check_terms_read": "من شرایط خدمات بتا را خوانده ام.",
    "wizard_step_terms": "شرایط استفاده",
    "wizard_terms_text": "شرایط استفاده از GaiaCom و توافقنامه آزمایش بتا (فاز بتا)\n\nارائه دهنده: VisionGaiaTechnology (از این پس \"ارائه دهنده\" نامیده می شود)\nوضعیت: مرحله آزمایش بتا عمومی\nاعتبار: از 21 ژوئن 2026\n\n⚠️ مهم ترین نکته از قبل (لطفا با دقت بخوانید)\nGaiaCom در مرحله آزمایش عمومی بتا است. علیرغم اقدامات امنیتی گسترده، رهایی از خطا، در دسترس بودن مداوم یا امنیت مطلق نرم افزار و زیرساخت های زیربنایی را نمی توان تضمین کرد. با مسئولیت خود استفاده کنید. کاربران مسئول ذخیره ایمن داده های دسترسی خود (به ویژه کلیدهای GaiaVault) و رعایت قوانین قابل اجرا هستند.\n\n1. موضوع و هدف مرحله آزمایش بتا\n1.1. هدف از ارائه: GaiaCom یک سرویس ایمیل و چت جدید مبتنی بر رمزنگاری پس کوانتومی (PQC) است. ارائه در مرحله بتا منحصراً برای آزمایش فنی، شبیه‌سازی بار، یافتن خطاهای برنامه (باگ‌ها) و بهینه‌سازی کاربرپسندی در نظر گرفته شده است.\n1.2. وضعیت بتا: کاربر آگاه است که نرم افزار ارائه شده یک نسخه اولیه (نرم افزار بتا) است. این هنوز از نظر فنی به طور کامل توسعه نیافته است، استانداردهای یک محصول تجاری نهایی را برآورده نمی کند و می تواند باعث خطا، از دست دادن داده، تاخیر در انتقال یا خرابی سیستم شود.\n1.3. بدون حق ادامه: ارائه دهنده حق دارد در هر زمان خدمات را به طور کامل یا جزئی قطع کند، عملکردها را تغییر یا محدود کند یا آنها را به طور موقت یا دائم بدون ذکر دلیل حذف کند.\n\n2. در دسترس بودن و سلب مسئولیت از گارانتی\n2.1. بدون ضمانت در دسترس بودن: GaiaCom بدون هیچ ضمانتی در مورد در دسترس بودن یا آپتایم ارائه می شود. حق دسترسی بدون وقفه خدمات وجود ندارد.\n2.2. محرومیت از گارانتی: نرم افزار در وضعیت فعلی (\"همانطور که هست\") و مشروط به در دسترس بودن ارائه می شود. تا جایی که قانون اجازه دهد، هرگونه ادعای ضمانت برای نقص مادی و قانونی در نرم افزار مستثنی است. به طور خاص، هیچ تضمینی وجود ندارد که نرم افزار بدون خطا، عاری از بدافزار یا مناسب برای یک هدف خاص باشد.\n\n3. مدیریت ریسک و تعهدات کاربر\n3.1. ممنوعیت ذخیره سازی داده های حیاتی: کاربر متعهد می شود که به طور انحصاری اطلاعات مهم تجاری، حیاتی، عملیاتی ضروری یا از نظر قانونی خاص حساس (مانند پرونده های بیمار، داده های مالی بسیار حساس یا اسرار رسمی تنظیم شده) را ذخیره یا از طریق GaiaCom منتقل نکند. این سرویس نمی‌تواند برای زیرساخت‌هایی استفاده شود که خرابی‌های پیش‌بینی‌نشده می‌تواند منجر به صدمات شخصی، آسیب مالی یا ضرر مالی قابل توجه شود.\n3.2. تهیه نسخه پشتیبان با مسئولیت شخصی: کاربر مسئول تهیه نسخه پشتیبان از کلیه داده های دریافت یا ارسال شده از طریق GaiaCom است که در درازمدت به آنها در سیستم های مستقل و مستقل خود (نسخه های پشتیبان) نیاز دارد. ارائه دهنده ذخیره سازی یا بازیابی دائمی داده ها در سرورهای خود را تضمین نمی کند.\n\n4. ویژگی های رمزنگاری و GaiaVault\n4.1. رمزنگاری پس کوانتومی (PQC): GaiaCom فرآیندهای رمزگذاری پیشرفته و آینده‌گرا را پیاده‌سازی می‌کند که برای مقاومت در برابر حملات رایانه‌های کوانتومی آینده طراحی شده‌اند. با این حال، کاربر آگاه است که این یک زمینه علمی پویا و جدید است. امنیت مطلق و غیرقابل انکار را نمی توان بر اساس وضعیت فعلی علم و فناوری تضمین کرد. عباراتی مانند \"100% ایمن\"، \"غیرقابل شکست\" یا \"امن نظامی\" به صراحت تضمین نمی شوند.\n4.2. بدون ضمانت بازیابی (GaiaVault): GaiaCom بر یک مفهوم امنیتی با دانش صفر متکی است. گوه های رمزگذاری و داده های دسترسی فقط در کنترل کاربر باقی می مانند (از طریق GaiaVault ایمن می شوند).\nمهم: اگر کاربر رمز عبور، عبارات عبور، کلیدهای خصوصی یا دانه‌های بازیابی خود را گم کند، ارائه‌دهنده هیچ توانایی فنی برای بازسازی یا بازنشانی این داده‌ها ندارد. از دست دادن این داده های دسترسی به ناچار منجر به از دست دادن غیرقابل برگشت دسترسی به حساب کاربری و تمام داده های رمزگذاری شده در آن می شود.\n4.3. هنوز به طور کامل ممیزی نشده است: این نرم افزار به طور مداوم تحت بررسی های امنیتی داخلی قرار می گیرد، اما در زمان این مرحله بتا هنوز مورد بازرسی نهایی و جامع امنیت خارجی توسط نهادهای آزمایش مستقل قرار نگرفته است.\n\n5. رابط ها، پروتکل های قدیمی و فدراسیون\n5.1. SMTP Bridge توجه: GaiaCom امکان برقراری ارتباط از طریق پروتکل های ایمیل کلاسیک (مانند SMTP) را ارائه می دهد. کاربر می‌داند که پیام‌هایی که از ناحیه امنیتی GaiaCom خارج می‌شوند (مثلاً زمانی که به آدرس @gmail.com یا @gmx.de مرسوم ارسال می‌شوند) از طریق سرورهای رمزگذاری نشده یا شخص ثالث منتقل می‌شوند. ضمانت‌های امنیتی سرتاسر GaiaCom فقط به میزان محدودی اعمال می‌شود یا اصلاً در مورد پیام‌های قدیمی خروجی یا ورودی خارجی اعمال نمی‌شود.\n5.2. توجه فدراسیون: اگر GaiaCom در یک شبکه فدرال کار می کند، پیام ها و داده ها ممکن است از طریق سرورهای شخص ثالث منتقل شوند. در حالی که محتویات پیام‌ها با رمزگذاری سرتاسر محافظت می‌شوند، ابرداده‌ها (مانند زمان ارسال، آدرس‌های IP سرورهای درگیر و آدرس‌های گیرنده) ممکن است از نظر فنی برای اپراتورهای این سرورهای فدرال قابل مشاهده باشند. ارائه‌دهنده هیچ تأثیری بر رویه‌های حفاظت از داده‌های اپراتورهای سرور شخص ثالث در شبکه فدرال ندارد.\n\n6. استفاده های قابل قبول و فعالیت های ممنوع\nکاربر متعهد می شود که از خدمات به صورت نادرست یا برای مقاصد غیرقانونی استفاده نکند. به ویژه موارد زیر ممنوع است:\n- توزیع، ارسال یا میزبانی ویروس ها، بدافزارها، محتوای فیشینگ یا سایر نرم افزارهای مخرب.\n- استفاده از سرویس برای انجام حملات انکار سرویس (DDoS) یا ارسال نامه های انبوه ناخواسته (هرزنامه).\n- سوء استفاده از سیستم برای ارتکاب کلاهبرداری.\n- توزیع یا مبادله محتوای غیرقانونی، به ویژه تصاویر سوء استفاده جنسی از کودکان (CSAM)، تبلیغات تروریستی، دعوت به خشونت یا سایر محتوای مرتبط با جنایت.\n\n7. سیستم گزارش تخلف\n7.1. گزارش رفتار توهین آمیز: کاربران این فرصت را دارند که از طریق سیستم یکپارچه سوء استفاده، ارتباطات توهین آمیز یا فعالیت های غیرقانونی را گزارش کنند.\n7.2. پردازش گزارش‌ها: به منظور اطمینان از محافظت در برابر سوء استفاده، گزارش‌های دریافتی را می‌توان از نظر فنی تحلیل کرد (با حفظ حریم خصوصی و محدودیت‌های رمزگذاری). این امر می تواند منجر به تعلیق موقت یا دائمی حساب های کاربری یا آدرس های IP در صورت نقض اثبات شده این شرایط استفاده شود.\n\n8. محدودیت مسئولیت\n8.1. استاندارد مسئولیت: نرم افزار بتا به صورت رایگان ارائه می شود. بر اساس قوانین قانونی برای اهدا یا وام، ارائه دهنده تنها در قبال عمد (خسارت عمدی) و سهل انگاری فاحش مسئولیت دارد.\n8.2. محرومیت از مسئولیت از دست دادن داده ها: مسئولیت از دست دادن داده ها مستثنی است، مگر اینکه از دست دادن به عمد یا در اثر سهل انگاری فاحش توسط ارائه دهنده ایجاد شده باشد و کاربر تعهد خود را برای کاهش خسارت از طریق پشتیبان گیری منظم (خارج از GaiaCom) انجام داده باشد.\n8.3. محدودیت های قانونی: محدودیت های مسئولیت فوق در مورد آسیب به جان، بدن یا سلامتی یا مسئولیت تحت قانون مسئولیت محصول اعمال نمی شود.\n\n9. متن باز\nبرخی از مؤلفه‌ها، کتابخانه‌ها یا برنامه‌های سرویس گیرنده GaiaCom ممکن است تحت مجوزهای منبع باز مجوز داشته باشند (مانند GPL، MIT، Apache). شرایط مجوز مربوطه این مؤلفه‌ها تحت تأثیر این شرایط استفاده قرار نگرفته و می‌توانند در مخازن کد منبع مربوطه مشاهده شوند.\n\n10. کنترل صادرات و انطباق\nکاربر می‌داند که نرم‌افزار رمزنگاری ممکن است تحت کنترل‌های سخت‌گیرانه صادرات و محدودیت‌های قانونی باشد. کاربر مسئول اطمینان از این است که استفاده از GaiaCom قوانین، محدودیت‌های واردات/صادرات یا مقررات رمزنگاری کشور محل اقامت خود را نقض نمی‌کند.\n\n11. اطلاعیه حفاظت از داده ها (نسخه کوتاه برای نسخه بتا)\n11.1. جمع‌آوری حداقل داده‌ها: به عنوان بخشی از مرحله بتا، ارائه‌دهنده تنها داده‌هایی را جمع‌آوری می‌کند که برای عملیات فنی، عیب‌یابی و توسعه بیشتر ضروری است (مانند فایل‌های گزارش سرور برای تشخیص خطا).\n11.2. بدون بینش در مورد محتوا: به لطف دانش صفر و رمزگذاری E2E، ارائه‌دهنده هرگز به محتوای چت‌ها، ایمیل‌ها یا کلیدهای ذخیره شده در GaiaVault دسترسی ندارد.\n11.3. اعلامیه دقیق حفاظت از داده ها: مقررات دقیق حفاظت از داده ها به طور جداگانه پیوند داده شده است و همچنین باید قبل از ثبت نام توسط کاربر در نظر گرفته شود.\n\n12. مقررات نهایی\n12.1. قانون قابل اجرا: قانون جمهوری فدرال آلمان، به استثنای کنوانسیون سازمان ملل متحد در مورد قراردادهای فروش بین المللی کالا، اعمال می شود.\n12.2. مشروط به تغییر: از آنجایی که GaiaCom در حال توسعه فعال است، ارائه‌دهنده این حق را برای خود محفوظ می‌دارد که در هر زمان این شرایط را با اثرگذاری برای آینده تطبیق دهد. نسخه فعلی در برنامه موجود است.",
    "wizard_terms_title": "شرایط استفاده از GaiaCom و توافقنامه آزمایش بتا (فاز بتا)",
    "node_operator": "اپراتور گره",
    "search_channels": "جستجوی کانال ها...",
    "senior_reviewer": "داور ارشد",
    "trusted_reviewer": "داور مورد اعتماد",
    "active_frequencies": "فرکانس های فعال",
    "connected_rooms": "فضاهای متصل",
    "dashboard": "داشبورد",
    "empty_chats": "هیچ چت فعالی در دسترس نیست.",
    "empty_messages": "هیچ پیام جدیدی در دسترس نیست.",
    "encrypted": "رمزگذاری شده است",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "برنامه را نصب کنید",
    "install_app_desc": "برای شروع سریع و حالت آفلاین",
    "kommandozentrale_alpha": "مرکز فرماندهی ALPHA",
    "network_online": "شبکه: آنلاین",
    "new_room": "فضای جدید",
    "no_frequencies_active": "هیچ فرکانس فعالی نیست یک اتاق جدید برای شروع ارتباط ایجاد کنید.",
    "no_id": "بدون شناسه",
    "open_chats": "چت ها را باز کنید",
    "open_inbox": "صندوق ورودی را باز کنید",
    "primary_identity": "هویت اولیه",
    "recent_chats": "چت های جدید",
    "recent_messages": "آخرین اخبار",
    "session_encrypted": "جلسه رمزگذاری شده: {name}",
    "session_secure": "وضعیت: امن",
    "system_verlassen": "سیستم خروج",
    "write_message": "پیام بنویس",
    "onboarding_step_profile": "پروفایل",
    "onboarding_step_security": "امنیت",
    "onboarding_step_backup": "پشتیبان",
    "onboarding_step_launch": "شروع",
    "onboarding_loading_gaia_id": "در حال بارگذاری شناسه گایا",
    "onboarding_setup_kicker": "راه‌اندازی اولیه گایاکام",
    "onboarding_profile_title": "گایاکام را به فضای خود تبدیل کنید.",
    "onboarding_profile_desc": "نام نمایشی و آواتار شما به صورت محلی کنترل می‌شوند و بعداً در هر زمان در پروفایل قابل تغییر هستند.",
    "onboarding_security_title": "آنچه گایاکام اکنون برای شما محافظت می‌کند.",
    "onboarding_security_desc": "گایاکام هویت، کلیدها، پیام‌ها و وضعیت شبکه را جدا می‌کند. شما در اینجا فقط نسخه کوتاه کاربر را می‌بینید.",
    "onboarding_backup_title": "پشتیبان‌گیری راه نجات واقعی شماست.",
    "onboarding_backup_desc": "بدون داده‌های بازیابی، هیچ‌کس نمی‌تواند هویت شما را نجات دهد. این دقیقاً هدف امنیت واقعی سرتاسری است.",
    "onboarding_launch_title": "آماده. می‌خواهید ابتدا چه کاری انجام دهید؟",
    "onboarding_launch_desc": "می‌توانید بلافاصله شروع کنید یا تور را پایان دهید و در داشبورد به کار خود ادامه دهید.",
    "onboarding_display_name": "نام نمایشی",
    "onboarding_display_name_placeholder": "چگونه گایاکام نام شما را نشان دهد؟",
    "onboarding_select_avatar": "انتخاب آواتار",
    "onboarding_sec_identity_title": "هویت",
    "onboarding_sec_identity_desc": "شناسه گایا لنگر شبکه شماست. مخاطبین می‌توانند تعویض کلیدها را شناسایی کنند.",
    "onboarding_sec_messages_title": "پیام‌ها",
    "onboarding_sec_messages_desc": "محتوا به صورت محلی رمزگشایی می‌شود. پیام‌های ویرایش شده امضاهای جدیدی دریافت می‌کنند.",
    "onboarding_sec_network_title": "شبکه",
    "onboarding_sec_network_desc": "مرکز امنیت و مرکز گزارش تخلف، ریسک‌ها را بدون در پشتی جهانی نمایان می‌کنند.",
    "onboarding_sec_transparency_title": "شفافیت",
    "onboarding_sec_transparency_desc": "رویدادهای امنیتی را در پروتکل ثبت می‌کند تا هشدارها قابل پیگیری باشند.",
    "onboarding_backup_notice_title": "مهم برای کاربران عادی",
    "onboarding_backup_notice_desc": "داده‌های بازیابی خود را جدا از این دستگاه ذخیره کنید. در صورت گم شدن رمز عبور و پشتیبان، گایاکام عمداً قفل می‌ماند.",
    "onboarding_backup_consent": "من می‌دانم که پشتیبان من برای بازیابی و تغییر دستگاه حیاتی است.",
    "onboarding_inbox_title": "صندوق ورودی",
    "onboarding_inbox_desc": "خواندن ایمیل‌ها و نوشتن اولین پیام.",
    "onboarding_contacts_title": "مخاطبین",
    "onboarding_contacts_desc": "بررسی اولین مخاطب یا شروع چت.",
    "onboarding_channels_title": "کانال‌ها",
    "onboarding_channels_desc": "کشف فرکانس‌های عمومی.",
    "onboarding_security_title_card": "مرکز امنیت",
    "onboarding_security_desc_card": "مشاهده وضعیت گایاشیلد.",
    "onboarding_later": "بعداً",
    "onboarding_back": "برگشت",
    "onboarding_continue": "ادامه",
    "onboarding_complete_setup": "تکمیل راه‌اندازی",
    "auth_legal_consent": "من قوانین حریم خصوصی و شرایط استفاده را خوانده و با آن موافقم.",
    "auth_show_terms": "نمایش شرایط استفاده",
    "auth_recovery_mode": "حالت بازیابی",
    "auth_recovery_import_title": "وارد کردن فایل بازیابی",
    "auth_recovery_import_desc": "کلیدهای GaiaCom خود را از یک فایل پشتیبان محافظت شده با رمز عبور بازیابی کنید. پس از آن، عبارت یادآور و نام کاربری از پیش پر می‌شوند.",
    "auth_recovery_file_pwd_placeholder": "رمز عبور فایل بازیابی",
    "auth_recovery_local_pwd_placeholder": "رمز عبور محلی جدید برای باز کردن قفل حداقل ۱۲ کاراکتر",
    "auth_recovery_importing": "در حال وارد کردن...",
    "auth_recovery_decrypt": "رمزگشایی بازیابی",
    "auth_back_to_login": "بازگشت به ورود",
    "auth_terms_title": "شرایط استفاده نسخه آزمایشی گایاکام",
    "auth_terms_close": "بستن",
    "auth_cookie_title": "گایاکام مستقل باقی می‌ماند.",
    "auth_cookie_desc": "ما فقط از حافظه محلی از نظر فنی ضروری برای زبان، نشست و امنیت استفاده می‌کنیم. بدون ردیابی، بدون کوکی‌های تبلیغاتی، بدون پروفایل‌های شخص ثالث.",
    "auth_cookie_accept": "فهمیدم",
    "sc_explainer_title": "در اینجا واقعاً چه چیزی محافظت می‌شود؟",
    "sc_explainer_desc": "گایاشیلد لایه محافظ بین حساب شما، پیام‌های شما و شبکه است. این لایه در مورد محتوا تصمیم نمی‌گیرد، بلکه در مورد ریسک‌های فنی تصمیم‌گیری می‌کند: دستکاری، تلاش‌های تکرار، دسترسی غیرمجاز، الگوهای ورود مشکوک و انتقال‌های ناامن درگاه.",
    "sc_explainer_identity_desc": "ناهنجاری‌های ورود، ریسک‌های نشست و دسترسی به دیگر هویت‌ها را بررسی می‌کند.",
    "sc_explainer_messages_desc": "الگوهای تکرار، بسته‌های دستکاری‌شده و نبود ویژگی‌های یکپارچگی را شناسایی می‌کند.",
    "sc_explainer_network_desc": "ریسک‌های فدراسیون، محدودیت سرعت و SMTP را پیش از آنکه اعتماد به اشتباه نشان داده شود، علامت‌گذاری می‌کند.",
    "sc_open_security_warnings": "هشدارهای امنیتی باز",
    "sc_opt_all": "همه",
    "sc_opt_low": "کم",
    "sc_opt_medium": "متوسط",
    "sc_opt_high": "زیاد",
    "sc_opt_critical": "بحرانی",
    "sc_opt_failed_login": "ورود ناموفق",
    "sc_opt_auth_attack": "حمله احراز هویت",
    "sc_opt_rate_limit": "محدودیت نرخ درخواست",
    "sc_opt_policy_violation": "هشدار خط‌مشی",
    "sc_opt_message_replay": "تکرار پیام",
    "sc_node_security_data_unavailable": "داده‌های امنیتی گره در دسترس نیست",
    "sc_total_events": "کل رویدادها",
    "sc_login_attacks": "حملات ورود",
    "sc_rate_limits_active": "محدودیت‌های نرخ فعال",
    "sc_smtp_shield_hits": "سپر حفاظتی SMTP",
    "sc_top_event_categories": "دسته‌بندی‌های برتر رویدادها",
    "sc_no_entries": "هیچ موردی ثبت نشده است.",
    "sc_node_audit_log": "دفترچه ممیزی گره (اخیر)",
    "sc_no_node_events": "رویدادی برای گره ثبت نشده است.",
    "archiv": "بایگانی",
    "entwuerfe": "پیش‌نویس‌ها",
    "markiert": "ستاره‌دار",
    "wichtig": "مهم",
    "snoozed": "به تعویق افتاده",
    "papierkorb": "زباله‌دان",
    "spam": "هرزنامه",
    "cancel": "لغو",
    "error": "خطا",
    "success": "موفقیت",
    "kopieren": "کپی کردن",
    "block_contact": "مسدود کردن مخاطب",
    "unblock_contact": "رفع مسدودیت مخاطب",
    "report_contact": "گزارش مخاطب",
    "check_fingerprint": "تایید اثر انگشت",
    "export_encrypted": "خروجی (رمزگذاری شده)",
    "export_gaiaproof": "خروجی (GaiaProof)",
    "export_password_prompt": "لطفاً یک رمز عبور برای رمزگذاری خروجی گپ وارد کنید:",
    "export_success": "گپ با موفقیت صادر و رمزگذاری شد.",
    "export_failed": "صدور ناموفق بود: ",
    "gaiaproof_export_success": "بسته GaiaProof با موفقیت صادر شد.",
    "gaiaproof_export_failed": "صدور GaiaProof ناموفق بود: ",
    "export_gaiaproof_confirm": "آیا می‌خواهید بسته GaiaProof را با تمام امضاها و رسیدهای تحویل سرور دانلود کنید؟ این کار ممکن است کمی طول بکشد.",
    "group_settings_is_private": "اتاق خصوصی (غیر قابل جستجوی عمومی، فقط از طریق درخواست عضویت)",
    "group_settings_read_only": "حالت فقط خواندنی (فقط مالک و مدیران می‌توانند پیام ارسال کنند)",
    "group_settings_slow_mode": "حالت کند (زمان خنک‌سازی ارسال)",
    "gsn_title": "خوراک اجتماعی GSN",
    "gsn_node_feed": "خوراک گره",
    "gsn_following_feed": "دنبال‌شونده‌ها",
    "gsn_feed_empty": "هیچ پستی یافت نشد.",
    "gsn_composer_placeholder": "چه خبر در فدراسیون؟",
    "gsn_post_btn": "اشتراک‌گذاری",
    "gsn_profile": "پروفایل کاربر",
    "gsn_followers": "دنبال‌کننده‌ها",
    "gsn_following": "دنبال‌شونده‌ها",
    "gsn_bio": "توضیحات / بیوگرافی:",
    "gsn_bio_label": "توضیحات / بیوگرافی",
    "gsn_display_name": "نام نمایشی",
    "gsn_edit_profile": "ویرایش پروفایل",
    "gsn_save_profile": "ذخیره",
    "gsn_add_image": "افزودن تصویر (رمزگذاری شده)",
    "gsn_add_emoji": "درج شکلک",
    "gsn_avatar_emoji": "آواتار (شکلک)",
    "gsn_follow": "دنبال کردن",
    "gsn_unfollow": "لغو دنبال کردن",
    "gsn_repost": "اشتراک‌گذاری / بازنشر",
    "gsn_post_created": "پست با موفقیت به اشتراک گذاشته شد.",
    "gsn_image_uploaded": "تصویر رمزگذاری و بارگذاری شد.",
    "gsn_upload_failed": "بارگذاری تصویر ناموفق بود: ",
    "gsn_comment_placeholder": "نوشتن یک دیدگاه...",
    "gsn_delete_confirm_title": "حذف پست؟",
    "gsn_delete_confirm_desc": "آیا مطمئن هستید که می‌خواهید این پست را برای همیشه حذف کنید؟",
    "gsn_delete_comment_confirm_title": "حذف دیدگاه?",
    "gsn_delete_comment_confirm_desc": "آیا مطمئن هستید که می‌خواهید این دیدگاه را برای همیشه حذف کنید؟",
    "gsn_report": "گزارش کردن",
    "gsn_report_title": "گزارش تخلف",
    "gsn_report_category": "دسته‌بندی",
    "gsn_report_spam": "هرزنامه / تبلیغات",
    "gsn_report_harassment": "آزار و اذیت / سخنان نفرت‌انگیز",
    "gsn_report_abuse": "سوءاستفاده",
    "gsn_report_illegal": "محتوای غیرقانونی",
    "gsn_report_severity": "شدت",
    "gsn_report_low": "کم",
    "gsn_report_medium": "متوسط",
    "gsn_report_high": "زیاد",
    "gsn_report_comment": "توضیحات تکمیلی",
    "gsn_report_submit": "گزارش کردن",
    "gsn_report_submitted": "گزارش به بخش حاکمیت ارسال شد.",
    "gsn_report_post": "گزارش پست",
    "report_group": "گزارش گروه",
    "report_group_reason_prompt": "لطفاً علت گزارش را وارد کنید (اختیاری):",
    "report_reason_prompt": "لطفاً علت گزارش را وارد کنید (اختیاری):",
    "report_failed": "گزارش ناموفق بود: ",
    "report_success": "مخاطب با موفقیت گزارش شد.",
    "room_read_only_placeholder": "فقط مالک و مدیران می‌توانند بنвесенд",
    "read_only_active": "حالت فقط خواندنی",
    "slow_mode_active": "حالت کند فعال است",
    "kommandozentrale": "مرکز فرماندهی",
    "kontakt_blockiert": "مخاطب مسدود شد",
    "kontakt_freigegeben": "مخاطب رفع مسدودیت شد",
    "mailbox_settings_title": "تنظیمات صندوق پستی",
    "mailbox_settings_desc": "مدیریت امضا، زبان و فیلترهای ایمیل.",
    "mic_access_denied": "دسترسی به میکروفون رد شد: ",
    "no_frequencies_active_desc": "برای شروع ارتباط یک اتاق جدید ایجاد کنید.",
    "key_changed_warning_title": "هشدار امنیتی:",
    "key_changed_warning_desc": "کلید هویت این فرستنده به‌روزرسانی شده یا با کلید قبلی متفاوت است. لطفاً اثر انگشت را از طریق کانال امن دیگری تأیید کنید.",
    "sc_col_category": "دسته‌بندی",
    "search_members": "جستجوی اعضا...",
    "tab_general": "عمومی",
    "tab_members": "اعضا",
    "tab_requests": "درخواست‌ها",
    "tab_invites": "دعوت‌نامه‌ها",
    "tab_logs": "گزارش‌ها",
    "auth_why_gaiacom": "چرا GaiaCOM؟",
    "auth_why_gaiacom_desc": "جایگزین امن و غیرمتمرکز برای ارتباطات محرمانه شما.",
    "auth_self_managed_id": "شناسه خود‌مدیریتی",
    "auth_self_managed_id_desc": "بدون نیاز به ایمیل یا شماره تلفن، فوراً هویت‌های رمزنگاری امن ایجاد کنید.",
    "auth_gaiadrop_secure_exchange": "تبادل امن بدون حساب کاربری",
    "auth_gaiadrop_benefit_e2ee": "رمزگذاری سرتاسری",
    "auth_gaiadrop_benefit_no_login": "بدون نیاز به ورود",
    "auth_gaiadrop_benefit_inbox": "تحویل مستقیم به صندوق ورودی گیرنده",
    "auth_terms_of_use": "شرایط استفاده",
    "auth_terms_of_use_show": "نمایش شرایط استفاده",
    "auth_consent_privacy_terms": "من سیاست حریم خصوصی و شرایط استفاده را خوانده‌ام و با آن‌ها موافقم.",
    "auth_recovery_import_file": "وارد کردن فایل بازیابی",
    "auth_recovery_password": "رمز عبور فایل بازیابی",
    "auth_recovery_local_password": "رمز عبور جدید محلی برای باز کردن قفل حداقل ۱۲ کاراکتر",
    "auth_recovery_decrypting": "رمزگشایی بازیابی...",
    "auth_recovery_back": "بازگشت به صفحه ورود",
    "auth_cookie_sovereign": "GaiaCOM مستقل می‌ماند.",
    "auth_cookie_sovereign_desc": "ما فقط از ویژگی‌های ذخیره‌سازی محلی فنی لازم برای زبان، جلسه و امنیت استفاده می‌کنیم. بدون ردیابی، بدون کوکی‌های تبلیغاتی، بدون پروفایل‌های شخص ثالث.",
    "auth_cookie_sovereign_accept": "فهمیدم",
    "unlock_keyboard_toggle": "⌨️ استفاده از صفحه‌کلید",
    "unlock_keypad_toggle": "🔢 استفاده از صفحه‌کلید پین",
    "unlock_status_denied": "دسترسی رد شد / تلاش مجدد",
    "unlock_status_decrypting": "در حال رمزگشایی صندوق...",
    "unlock_status_secured": "صندوق ایمن / قفل شده",
    "auth_landing_nav_legal": "حقوقی",
    "auth_landing_nav_beta": "تست بتا",
    "auth_landing_card1_title": "رمزنگاری پس از کوانتومی (ML-KEM)",
    "auth_landing_card2_title": "۱۰۰٪ غیرمتمرکز",
    "auth_landing_card3_title": "دانش صفر",
    "auth_landing_card4_title": "محافظت از فراداده",
    "auth_landing_card5_title": "شناسه مدیریت شده توسط خود",
    "auth_landing_hybrid_title": "رمزنگاری امروز به علاوه محافظت در برابر تهدیدات فردا.",
    "auth_landing_hybrid_desc": "پروتکل GaiaCom تبادل کلید کلاسیک اثبات‌شده را با کپسوله‌سازی کلید پس از کوانتومی ترکیب می‌کند. دفاع در عمق.",
    "auth_landing_x25519_desc": "تبادل کلید منحنی بیضوی سریع و اثبات‌شده برای دستگاه‌های فعلی و نشست‌های امن.",
    "auth_landing_mlkem_desc": "کپسوله‌سازی کلید پس از کوانتومی برای محرمانگی بلندمدت در برابر سناریوهای فک تشفیف بعدی.",
    "auth_landing_cycle_title": "سرور هیچ‌چیز نمی‌بیند. شبکه فقط نویز منتقل می‌کند.",
    "auth_landing_step1_title": "رمزگذاری محلی",
    "auth_landing_step1_desc": "پیام قبل از رسیدن به شبکه یا سرور، روی دستگاه فرستنده رمزگذاری می‌شود.",
    "auth_landing_step2_title": "انتقال به عنوان بلاب (Blob)",
    "auth_landing_step2_desc": "بسته به عنوان نویز رمزنگاری از طریق گره‌های فدرال یا لایه‌های ذخیره‌سازی غیرمتمرکز منتقل می‌شود.",
    "auth_landing_step3_title": "ذخیره‌سازی فدرال",
    "auth_landing_step3_desc": "هیچ صندوق پستی مرکزی به عنوان هدف وجود ندارد. داده‌ها خرد شده، فدرال و کاملاً رمزگذاری شده‌اند.",
    "auth_landing_step4_title": "رمزگشایی محلی",
    "auth_landing_step4_desc": "فقط کلید خصوصی گیرنده می‌تواند بلاب رمزگذاری شده را دوباره به محتوای قابل خواندن تبدیل کند.",
    "auth_landing_trinity_title": "یک مفهوم پروتکل. سه سطح زیرساخت.",
    "auth_landing_enterprise_desc": "برای شرکت‌ها، دفاتر حقوقی، کسب‌وکارهای متوسط و بانکداری خصوصی. کانال‌های ارتباطی بسته همراه با کنترل مدیریتی و پشتیبانی.",
    "auth_landing_enterprise_list1": "حاکمیت داخلی و مدیریت کاربران",
    "auth_landing_enterprise_list2": "گره میزبانی‌شده توسط خود یا کلاستر حاکمیتی مدیریت‌شده",
    "auth_landing_enterprise_list3": "توافق‌نامه سطح خدمات، پشتیبانی و ماژول‌های پیشرفته",
    "auth_landing_network_desc": "شبکه باز برای حریم خصوصی دیجیتال. بدون تجارت داده، زیرساختی برای ارتباطات آزاد و رمزگذاری‌شده.",
    "auth_landing_network_list1": "نرم‌افزار کلاینت متن‌باز",
    "auth_landing_network_list2": "گره‌های فدرال",
    "auth_landing_network_list3": "بدون کلید رمزگشایی مرکزی",
    "auth_landing_defend_desc": "زیرساخت اختصاصی و فوق امنیتی برای سازمان‌های دولتی و بخش‌های ارتباطی ایزوله.",
    "auth_landing_defend_list1": "استقرار کاملاً ایزوله از اینترنت (air-gapped)",
    "auth_landing_defend_list2": "برندسازی اختصاصی و ممیزی کد منبع",
    "auth_landing_defend_list3": "حاکمیت دیجیتال ملی",
    "auth_landing_gov_title": "پروتکل باز. اجرای تجاری. تفکیک حقوقی واضح.",
    "auth_landing_gov_desc": "پروتکل GaiaCom بخش‌های پروتکل باز، کلاینت‌های متن‌باز و زیرساخت‌های تجاری پیشرفته را از یکدیگر متمایز می‌کند. اعتماد از شفافیت سرچشمه می‌گیرد.",
    "auth_landing_price1_desc": "هزینه یک‌باره برای محافظت در برابر بات‌ها در فروشگاه‌های اپلیکیشن.",
    "auth_landing_price2_desc": "متن‌باز و رایگان برای کاربرانی که ترجیح می‌دهند خودشان کد را کامپایل کنند.",
    "auth_landing_price3_desc": "برای شرکت‌های متوسط، دفاتر وکالت و تیم‌های حساس.",
    "auth_landing_price4_desc": "برای شرکت‌های بزرگ، کلاسترهای با دسترسی بالا، LDAP و دسترسی ریشه.",
    "auth_landing_license1_desc": "حداکثر شفافیت کد برای ممیزی‌های جامعه کاربری.",
    "auth_landing_license2_desc": "حفاظت کپی‌لفت در برابر تصاحب ابری و شاخه‌های پروتکل بسته.",
    "auth_landing_license3_desc": "دسترسی ریشه، ممیزی امنیت، توافق‌نامه سطح خدمات و منطق کسب‌وکار اختصاصی.",
    "auth_landing_final_title": "مدل ارتباطی مبتنی بر عدم اعتماد.",
    "auth_landing_final_desc": "پروتکل GaiaCom به سادگی جایگزین ایمیل نمی‌شود. این سوال را مطرح می‌کند که چرا ارتباطات حساس هنوز بر سرورهای قابل خواندن و مفروضات قدیمی ۴۰ سال پیش استوار است.",
    "auth_landing_final_note": "توجه: این صفحه یک مفهوم زیرساختی و نقشه راه را توصیف می‌کند. وعده‌های امنیتی باید پیش از بهره‌برداری، توسط ممیزی‌های واقعی تأیید شوند."




  };

export default fa;